"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var mobx_react_1 = require("mobx-react");

var shared_1 = require("../../../shared");

var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));

var FieldsWrapper_1 = __importDefault(require("./styledComponents/FieldsWrapper"));

var Field_1 = __importDefault(require("./styledComponents/Field"));

var FieldLabel_1 = __importDefault(require("./styledComponents/FieldLabel"));

var SelectedDateWrapper_1 = __importDefault(require("./styledComponents/SelectedDateWrapper"));

var SelectedYear_1 = __importDefault(require("./styledComponents/SelectedYear"));

var SelectedDate_1 = __importDefault(require("./styledComponents/SelectedDate"));

var CalendarWrapper_1 = __importDefault(require("./styledComponents/CalendarWrapper"));

var ClearFieldIcon_1 = __importDefault(require("./styledComponents/ClearFieldIcon"));

var CalendarInput_1 = __importDefault(require("../CalendarInput"));

var NumberPicker_1 = __importDefault(require("../NumberPicker"));

var Input_1 = __importDefault(require("../Input"));

var Dropdown_1 = __importDefault(require("../Dropdown"));

var Actions_1 = __importDefault(require("../Actions"));

var moment = __importStar(require("moment"));

var DateRangeInput_meta_1 = require("./DateRangeInput.meta");

var mobx_1 = require("mobx");

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var Translate_1 = require("../Translate/Translate");

var DateRangeInput =
/** @class */
function (_super) {
  __extends(DateRangeInput, _super);

  function DateRangeInput(props) {
    var _this = _super.call(this, props) || this;

    _this.categoryKey = DateRangeInput_meta_1.DATE_RANGE_INPUT_CATEGORY_KEY;
    _this.componentKey = DateRangeInput_meta_1.DATE_RANGE_INPUT_COMPONENT_KEY;
    _this.startDate = '';
    _this.endDate = '';
    _this.activeField = 'start';
    _this.calendarView = 'calendar';

    _this.formatDateInput = function (date, locale, translate) {
      var formatting = _this.props.formatting;
      var formatOptions = formatting && formatting.dateInputFormat;

      if (formatOptions) {
        return ksys_app_template_1.utils.formatter.formatDateTime(locale, formatOptions, date, translate);
      }

      return date;
    };

    _this.formatSelectedDate = function (date, locale, translate) {
      var formatting = _this.props.formatting;
      var formatOptions = formatting && formatting.selectedDateFormat;

      if (formatOptions) {
        return ksys_app_template_1.utils.formatter.formatDateTime(locale, formatOptions, date, translate);
      }

      return date;
    };

    _this.startDate = props.startDate || '';
    _this.endDate = props.endDate || '';
    _this.dateField = props.selectedDateField;
    _this.selectedDate = _this.startDate;
    return _this;
  }

  DateRangeInput.prototype.setActiveField = function (activeField) {
    this.activeField = activeField;

    if (this.activeField === 'start') {
      this.selectedDate = this.startDate;
    }

    if (this.activeField === 'end') {
      this.selectedDate = this.endDate;
    }
  };

  DateRangeInput.prototype.setCalendarView = function (view) {
    this.calendarView = view;
  };

  DateRangeInput.prototype.handleChange = function () {
    var onChange = this.props.onChange;

    if (onChange) {
      onChange(this.startDate, this.endDate, this.dateField);
    }
  };

  DateRangeInput.prototype.setStartDate = function (value) {
    if (value === void 0) {
      value = '';
    }

    this.startDate = value;
    this.selectedDate = this.startDate;
    this.handleChange();
  };

  DateRangeInput.prototype.setEndDate = function (value) {
    if (value === void 0) {
      value = '';
    }

    this.endDate = value;
    this.selectedDate = this.endDate;
    this.handleChange();
  };

  Object.defineProperty(DateRangeInput.prototype, "labels", {
    get: function get() {
      var defaultLabels = {
        dateField: 'Date Field',
        startDate: 'Start Date',
        endDate: 'End Date'
      };
      return __assign(__assign({}, defaultLabels), this.props.labels || {});
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateRangeInput.prototype, "minimumDate", {
    get: function get() {
      if (this.activeField === 'end' && this.startDate) {
        return this.startDate;
      }

      return this.props && this.props.minumumDate || '1970-01-01';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateRangeInput.prototype, "maximumDate", {
    get: function get() {
      if (this.activeField === 'start' && this.endDate) {
        return this.endDate;
      }

      return this.props && this.props.maximumDate || '2099-01-01';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateRangeInput.prototype, "selectedYear", {
    get: function get() {
      var calendarValue = moment.utc(this.selectedDate || Date.now());
      return parseInt(calendarValue.format('YYYY'), 10);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateRangeInput.prototype, "calendarInputProps", {
    get: function get() {
      var _this = this;

      return {
        isFlat: true,
        value: this.selectedDate,
        minimumDate: this.minimumDate,
        dayNames: this.props && this.props.dayNames,
        monthNames: this.props && this.props.monthNames,
        // 86400000 represents 1 day in milliseconds
        maximumDate: this.maximumDate === '2099-01-01' ? '2099-01-01' : moment.utc(Date.parse(this.maximumDate) + 86400000).format('YYYY-MM-DD'),
        onChange: function onChange(value) {
          if (_this.activeField === 'start') {
            _this.setStartDate(value);
          } else if (_this.activeField === 'end') {
            _this.setEndDate(value);
          }

          _this.handleChange();
        }
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateRangeInput.prototype, "dateFieldProps", {
    get: function get() {
      var _this = this;

      var _a = this.props.dateFieldItems,
          dateFieldItems = _a === void 0 ? [] : _a;
      return {
        selectedItem: this.dateField,
        items: dateFieldItems,
        placeholder: this.labels.dateField,
        onChange: function onChange(value) {
          if (Array.isArray(value)) {
            _this.dateField = value.length > 0 ? value[0] : undefined;
          } else {
            _this.dateField = value;
          }

          _this.handleChange();
        }
      };
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(DateRangeInput.prototype, "yearInputProps", {
    get: function get() {
      var _this = this;

      return {
        value: this.selectedYear,
        startValue: parseInt(moment.utc(this.minimumDate).format('YYYY'), 10),
        endValue: parseInt(moment.utc(this.maximumDate).format('YYYY'), 10),
        onChange: function onChange(value) {
          if (_this.selectedDate && value) {
            var newDate = new Date(_this.selectedDate).setFullYear(value);
            _this.selectedDate = moment.utc(newDate).format('YYYY-MM-DD');
          } else if (value) {
            var newDate = new Date().setFullYear(value);
            _this.selectedDate = moment.utc(newDate).format('YYYY-MM-DD');
          }

          _this.calendarView = 'calendar';
        }
      };
    },
    enumerable: true,
    configurable: true
  });

  DateRangeInput.prototype.translateValue = function (translationContext, value) {
    return value ? translationContext.translate(value) : value;
  };

  DateRangeInput.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        dateFieldItems = _a.dateFieldItems,
        actionsProps = _a.actionsProps;

    var setYearView = function setYearView() {
      return _this.setCalendarView('year');
    };

    var setCalendarView = function setCalendarView() {
      return _this.setCalendarView('calendar');
    };

    var calendarView = this.calendarView;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className,
      key: this.activeField + "-" + this.startDate + "-" + this.endDate
    }, react_1.default.createElement(Translate_1.TranslationContext.Consumer, null, function (translationContext) {
      var culture = translationContext.culture,
          translate = translationContext.translate;
      return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(FieldsWrapper_1.default, null, !ksys_app_template_1.utils.typeChecks.isNullOrEmpty(dateFieldItems) && react_1.default.createElement(Field_1.default, null, react_1.default.createElement(FieldLabel_1.default, {
        value: _this.labels.dateField
      }), react_1.default.createElement(Dropdown_1.default, __assign({}, _this.dateFieldProps))), react_1.default.createElement(Field_1.default, null, react_1.default.createElement(FieldLabel_1.default, {
        value: _this.labels.startDate
      }), react_1.default.createElement(Input_1.default, {
        className: _this.activeField === 'start' ? 'active-field' : '',
        readOnly: true,
        placeholder: _this.labels.startDate,
        value: _this.formatDateInput(_this.startDate, culture, translate),
        onClick: function onClick() {
          return _this.setActiveField('start');
        }
      }), _this.startDate && react_1.default.createElement(ClearFieldIcon_1.default, {
        asset: 'base.dateRangeInput.clearField',
        onClick: function onClick() {
          return _this.setStartDate();
        }
      })), react_1.default.createElement(Field_1.default, null, react_1.default.createElement(FieldLabel_1.default, {
        value: _this.labels.endDate
      }), react_1.default.createElement(Input_1.default, {
        className: _this.activeField === 'end' ? 'active-field' : '',
        readOnly: true,
        placeholder: _this.labels.endDate,
        value: _this.formatDateInput(_this.endDate, culture, translate),
        onClick: function onClick() {
          return _this.setActiveField('end');
        }
      }), _this.endDate && react_1.default.createElement(ClearFieldIcon_1.default, {
        asset: 'base.dateRangeInput.clearField',
        onClick: function onClick() {
          return _this.setEndDate();
        }
      })), actionsProps && react_1.default.createElement(Actions_1.default, __assign({}, actionsProps))), react_1.default.createElement(SelectedDateWrapper_1.default, null, react_1.default.createElement(SelectedYear_1.default, {
        onClick: setYearView
      }, _this.selectedYear), react_1.default.createElement(SelectedDate_1.default, {
        onClick: setCalendarView
      }, _this.formatSelectedDate(_this.selectedDate || '', culture, translate))), react_1.default.createElement(CalendarWrapper_1.default, null, calendarView === 'calendar' && react_1.default.createElement(CalendarInput_1.default, __assign({}, _this.calendarInputProps)), calendarView === 'year' && react_1.default.createElement(NumberPicker_1.default, __assign({}, _this.yearInputProps))));
    }));
  };

  __decorate([mobx_1.observable], DateRangeInput.prototype, "dateField", void 0);

  __decorate([mobx_1.observable], DateRangeInput.prototype, "selectedDate", void 0);

  __decorate([mobx_1.observable], DateRangeInput.prototype, "startDate", void 0);

  __decorate([mobx_1.observable], DateRangeInput.prototype, "endDate", void 0);

  __decorate([mobx_1.observable], DateRangeInput.prototype, "activeField", void 0);

  __decorate([mobx_1.observable], DateRangeInput.prototype, "calendarView", void 0);

  __decorate([mobx_1.action], DateRangeInput.prototype, "setActiveField", null);

  __decorate([mobx_1.action], DateRangeInput.prototype, "setCalendarView", null);

  __decorate([mobx_1.action], DateRangeInput.prototype, "handleChange", null);

  __decorate([mobx_1.action], DateRangeInput.prototype, "setStartDate", null);

  __decorate([mobx_1.action], DateRangeInput.prototype, "setEndDate", null);

  __decorate([mobx_1.computed], DateRangeInput.prototype, "labels", null);

  __decorate([mobx_1.computed], DateRangeInput.prototype, "minimumDate", null);

  __decorate([mobx_1.computed], DateRangeInput.prototype, "selectedYear", null);

  __decorate([mobx_1.computed], DateRangeInput.prototype, "calendarInputProps", null);

  __decorate([mobx_1.computed], DateRangeInput.prototype, "dateFieldProps", null);

  __decorate([mobx_1.computed], DateRangeInput.prototype, "yearInputProps", null);

  DateRangeInput = __decorate([mobx_react_1.observer], DateRangeInput);
  return DateRangeInput;
}(shared_1.ComponentBase);

exports.DateRangeInput = DateRangeInput;
exports.default = shared_1.InjectedStyledComponent(DateRangeInput, DateRangeInput_meta_1.DATE_RANGE_INPUT_CATEGORY_KEY, DateRangeInput_meta_1.DATE_RANGE_INPUT_COMPONENT_KEY);